var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['overdot',_vm.myclass],attrs:{"title":_vm.needtitle?_vm.gettitle():''},domProps:{"innerHTML":_vm._s(_vm.gettitle())}})}
var staticRenderFns = []

export { render, staticRenderFns }